<template>
  <div class="main-container">
    <div class="main-wrapper" :class="{ blur: preview }">
      <div class="close-container">
        <CButton @click="onClose">
          <font-awesome-icon :icon="['fas', 'times']" />
        </CButton>
      </div>
      <CRow v-if="loaded" class="align-items-end h-100 p-3 container-content">
        <CCol
          v-for="(item, index) in content"
          class="text-center p-2 mb-3 col-md-2 col-sm-12"
          :key="index"
          :class="{ 'col-md-4 pb-3 col-sm-12': item.image != null }"
        >
          <img
            v-if="item.image != null"
            :src="baseUrl + '/cpr/Image/' + item.image"
            class="w-100"
          />
          <button
            v-else
            :id="'btnRef-' + index"
            :ref="'btn' + index"
            class="box title aligner-middle p-4 text-break"
            type="button"
            @click.prevent="onPreview(item, index)"
          >
            {{ $helpers.translate(item.message, lang) }}
          </button>
        </CCol>
      </CRow>
    </div>
    <div id="preview-modal" v-bind:class="{ hide: !preview }">
      <div class="text-right">
        <a class="close-preview" @click.prevent="onClosePreview()">
          <span aria-hidden="true">&times;</span>
        </a>
      </div>
      <div class="box p-4">
        <h3 class="p-0">{{ $helpers.translate(modal.title, this.lang) }}</h3>
        <p class="body">
          {{ $helpers.translate(modal.description, this.lang) }}
        </p>
        <img
          v-if="modal.image != ''"
          :src="baseUrl + '/cpr/Image/' + modal.image"
          class="w-80"
        />
      </div>
      <div class="mt-4 text-center">
        <button class="btn btn-cpr btn-primary" @click="onSelect()">
          เข้าสู่เนื้อหา
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "LessonContent",
  components: {},
  data() {
    return {
      data: [],
      lang: "th",
      loaded: false,
      courseCode: "",
      modalCode: "",
      preview: false,
      content: [],
      prevAction: "",
      modal: {
        title: "",
        image: "",
        description: "",
        action: "",
      },
      baseUrl: process.env.VUE_APP_URL_SOUND,
    };
  },
  computed: {
    ...mapGetters({
      templateContent: "template/getTemplateContent",
      templateModal: "template/getTemplateModal",
    }),
  },
  watch: {
    templateContent: function (val) {
      if(!val.enable){
        this.$router.push({name: val.navigate.close.action});
      }else{
        this.prevAction = val.navigate.previous.action
        this.content = val.content.item;
        this.loaded = true;
      }
    },
    templateModal: function (val) {
      this.modal.title = val.content.title;
      this.modal.description = "";
      this.modal.image = val.content.item[0].data;
      this.modal.action = val.navigate.next.action;
    },
  },
  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = "CPR-CS";
    this.$store.dispatch("template/fetchContent", body);
  },
  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
  },
  methods: {
    onClose() {
      this.$router.push({
        path: "/CPR/preview/" + this.prevAction,
      });
      //this.$router.push({name: this.close})
    },
    onPreview(item, index) {
      let body = {};
      body.code = this.courseCode;
      body.templateCode = item.button.action;
      this.$store.dispatch("template/fetchModal", body);
      this.preview = true;
      document.getElementById("preview-modal").style.left =
        document.getElementById("btnRef-" + index).getBoundingClientRect()
          .left + "px";
    },
    onClosePreview() {
      this.preview = false;
    },
    onSelect() {
      this.$router.push("/CPR/lessonContent/" + this.modal.action);
    },
  },
};
</script>
<style scoped>
@import "../../assets/scss/CPR/style.scss";
.main-container {
  /* background: transparent linear-gradient(224deg, #ffffff00 0%, #00000038 100%)
    0% 0% no-repeat padding-box; */
    background: #f3f3f3;
}
.main-wrapper {
  transition: all 0.5s ease;
  margin-left: 10%;
  margin-right: 10%;
}
.container-content {
  padding-top: 20% !important;
}
#preview-modal {
  position: absolute;
  width: 24%;
  top: 15%;
  left: 50%;
  margin-left: -6%;
}

#preview-modal h3 {
  font-size: 24px;
  text-align: center;
}
#preview-modal .body {
  text-align: left;
  color: #38adae;
}
#preview-modal .close-preview {
  font-size: 30px;
  cursor: pointer;
}
.hide {
  display: none;
}
.w-80 {
  width: 80%;
}
.title {
  width: 100%;
  min-height: 300px;
  display: inline-block;
  font-size: 25px;
}
.close-container {
  text-align: center;
  position: absolute;
  top: 15%;
  right: 5%;
  z-index: 9;
  /*background: transparent
    linear-gradient(139deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(139deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;*/
  background: #f3f3f3;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  opacity: 0.8;
  border-radius: 50%;
}
@media screen and (max-width: 1440px) {
  .title {
    font-size: 14px !important;
    min-height: 200px;
  }
}
@media screen and (max-width: 980px) {
  .main-wrapper {
    /*min-height: 100vh !important;*/
  }
}
@media screen and (max-width: 768px) {
  .main-wrapper {
    height: auto !important;
  }
}
</style>